module.exports = __webpack_public_path__ + "assets/images/user-placeholder.23hbd-5272fe84a8a2fe372732f6b4b328374c.jpg";